
import React,{useState,useEffect} from 'react';

import Head from './head';
import Nav from './nav';
import './css/profile.css';
import './css/btn.css';
import Footer from './footer';
import Scripts from './scripts';
import Reviews from './reviews';

import {onAuthStateChanged} from "firebase/auth";

import {signInWithGoogle, signOutWithGoogle, auth} from './Firebase';
import {API_BASE} from "../apiConfig";


function Profile (){
    const [loggedIn, setLoggedIn] = useState(true)
	const [revs, setRev] = useState([[]])
	// "loading" | "ready" | "error"
	const [reviewsState, setReviewsState] = useState("loading")

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setLoggedIn(!!user);
        });
        return unsubscribe;
    }, []);

		//when the page loads gets reviews for that dorm
	const getComments = async () => {
		let postParameters = {
			"email": localStorage.getItem("email")
		};

		try {
			const response = await fetch(`${API_BASE}/getProfile`, {
				method: 'post', body: JSON.stringify(postParameters),
				headers: {"Access-Control-Allow-Origin": "*"}
			});
			if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
			const reviews = await response.json();
			setRev(reviews['reviews'])
			setReviewsState("ready")
		} catch (error) {
			console.log("Error: Failed to fetch profile reviews", error)
			setReviewsState("error")
		}
	}

	useEffect(() => {
		getComments();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    return loggedIn ? (
		<div className="profile">
			<Head/>
			<Nav/>
			<div className="profile-header">
				<img className="profile-photo" src={localStorage.getItem("photo")} referrerpolicy="no-referrer" alt={localStorage.getItem("name") || "Your profile"}/>
				<h1>{localStorage.getItem("name")}</h1>
				<h4>Your Reviews</h4>
			</div>

			<div className="profile-reviews" >
				{reviewsState === "loading" ? (
					<div className="page-loading">
						<div className="spinner"></div>
						<p>Loading your reviews&hellip;</p>
					</div>
				) : reviewsState === "error" ? (
					<div className="page-error">
						<p>Couldn't load your reviews right now.</p>
						<button type="button" className="btn-secondary retry-btn" onClick={getComments}>Try again</button>
					</div>
				) : (
					<Reviews reviewlst={revs}/>
				)}
			</div>

			<div className="profile-signout">
				<button className="btn-secondary" onClick={signOutWithGoogle}>Sign out</button>
			</div>
			<Footer/>
			<Scripts/>
		</div>
    ) : (
		<div className="profile">
			<Head/>
			<Nav/>
			<div className="auth-message">
				<h4>You have successfully signed out</h4>
			</div>
			<Footer/>
			<Scripts/>
		</div>
	)
}

export default Profile;
